enum LoanDrawdownsActionsEnum {
    LoanDrawdownConditionsWithDocumentsList = 'LOAN_DRAWDOWN/CONDITIONS_WITH_DOCUMENTS/LIST',
    LoanDrawdownConditionsAdd = 'LOAN_DRAWDOWN/CONDITIONS/ADD',
    LoanDrawdownConditionsList = 'LOAN_DRAWDOWN/CONDITIONS/LIST',
    LoanDrawdownConditionsSet = 'LOAN_DRAWDOWN/CONDITIONS/SET',

    LoanDrawdownConditionSet = 'LOAN_DRAWDOWN/CONDITION/SET',
    LoanDrawdownConditionDelete = 'LOAN_DRAWDOWN/CONDITION/DELETE',

    LoanDrawdownConditionDocumentsAdd = 'LOAN_DRAWDOWN/CONDITION_DOCUMENTS/ADD',
    LoanDrawdownConditionDocumentsList = 'LOAN_DRAWDOWN/CONDITION_DOCUMENTS/LIST',
    LoanDrawdownConditionDocumentsSet = 'LOAN_DRAWDOWN/CONDITION_DOCUMENTS/SET',

    LoanDrawdownConditionDocumentDelete = 'LOAN_DRAWDOWN/CONDITION_DOCUMENT/DELETE',
    LoanDrawdownConditionDocumentSet = 'LOAN_DRAWDOWN/CONDITION_DOCUMENT/SET',
}

export default LoanDrawdownsActionsEnum;